// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1288": "201ca5f6","3526": "674a4a8f","8535": "e528f1d2",}[chunkId] + ".css"
}